var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-item-qty"},[_c('b-input',{attrs:{"type":"number","min":"0","step":"1","value":_vm.qty},on:{"input":_vm.update_qty}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }